// Function to validate form data
export const validateForm = (data, node, t) => {
  const newErrors = {
    name: '',
    manager: '',
    head: '',
  };

  // Validate name
  if (!data?.name?.trim()) {
    newErrors.name = t('department_name_is_required');
  }

  // Validate head for level 1 nodes
  if (node.level === 1) {
    // level 1: head can be either data.head (existing user ID) or data.invitedHead (new email)
    const hasHead = data.head || (data.invitedHead && data.invitedHead.trim());
    if (!hasHead) {
      newErrors.head = t('department_head_is_required');
    }
  }

  // Validate manager
  if (node.level === 1) {
    // For level 1, manager is not required (optional)
    // No validation needed for level 1 managers
  } else {
    // For other levels, manager should be a non-empty string
    if (!data.manager) {
      newErrors.manager = t('department_manager_is_required');
    }
  }

  // Return validation result
  return {
    errors: newErrors,
    isValid: !newErrors.name && !newErrors.manager && !newErrors.head,
  };
};

// Function to clear specific field error
export const clearFieldError = (errors, setErrors, fieldName) => {
  if (errors[fieldName]) {
    setErrors({
      ...errors,
      [fieldName]: '',
    });
  }
};
